"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var serve_worker_exports = {};
__export(serve_worker_exports, {
  getFetchStaticHtml: () => import_staticHtmlFetcher.getFetchStaticHtml,
  serve: () => serve,
  setFetchStaticHtml: () => import_staticHtmlFetcher.setFetchStaticHtml,
  withRange: () => import_assetRange.withRange
});
module.exports = __toCommonJS(serve_worker_exports);
var import_setServerGlobals = require("./server/setServerGlobals");
var import_setupBuildOptions = require("./server/setupBuildOptions");
var import_workerHandler = require("./server/workerHandler");
var import_ensureExists = require("./utils/ensureExists");
var import_staticHtmlFetcher = require("./server/staticHtmlFetcher");
var import_assetRange = require("./server/assetRange");
async function serve(buildInfo, lazyRoutes, serveOptions) {
  (0, import_setupBuildOptions.setupBuildInfo)(buildInfo);
  (0, import_ensureExists.ensureExists)(buildInfo.oneOptions);
  (0, import_setServerGlobals.setServerGlobals)();
  var handler = (0, import_workerHandler.createWorkerHandler)({
    oneOptions: buildInfo.oneOptions,
    buildInfo,
    lazyRoutes,
    disableModuleCache: serveOptions === null || serveOptions === void 0 ? void 0 : serveOptions.disableModuleCache
  });
  return {
    fetch: handler.handleRequest,
    updateRoutes(newBuildInfo, newLazyRoutes) {
      (0, import_setupBuildOptions.setupBuildInfo)(newBuildInfo);
      handler.updateRoutes(newBuildInfo, newLazyRoutes);
    }
  };
}
//# sourceMappingURL=serve-worker.js.map
